/* tslint:disable */
/* eslint-disable */
export enum InvoiceType {
  Invoice = 'INVOICE',
  Credit = 'CREDIT',
  Debit = 'DEBIT',
}
